import { compensateForScrollbar } from './general';

document.addEventListener('DOMContentLoaded', () => {
  const SELECTORS = {
    page: '.page',
    headerMenuContainer: '.header__navigation',
    headerMenu: '.header__menu',
    buttonMenu: '.header__button-menu',
    menuItemsSubmenu: '.menu__item--submenu > .menu__link'
  };

  const CLASSES = {
    menuDefault: 'menu-default',
    menuItemSubmenuShow: 'menu__item--submenu-show',
    menuLinkActive: 'menu__link--active',
    iconMenu: 'icon-menu_24',
    iconClose: 'icon-close_24',
    headerNavigationOpenMenu: 'header__navigation--open-menu',
    headerMenuShow: 'header__menu--show',
    pageFixed: 'page--fixed'
  };

  const BREAKPOINTS = {
    mobile: 1326
  };

  const page = document.querySelector(SELECTORS.page);
  const headerMenuContainer = document.querySelector(SELECTORS.headerMenuContainer);
  const headerMenu = document.querySelector(SELECTORS.headerMenu);
  const buttonMenu = document.querySelector(SELECTORS.buttonMenu);
  const menuItemsSubmenu = document.querySelectorAll(SELECTORS.menuItemsSubmenu);

  let screen = {
    width: window.innerWidth,
    height: window.innerHeight
  };

  // Обработчики событий
  const clickMenuItemSubmenuHandler = (evt) => {
    if (!headerMenu.classList.contains(CLASSES.menuDefault)) return;

    evt.preventDefault();
    const currentItem = evt.target.parentElement;
    const isOpenSubmenu = currentItem.classList.contains(CLASSES.menuItemSubmenuShow);
    const menuItems = [...currentItem.parentElement.children];

    // Закрываем все подменю и удаляем класс menu__link--active
    menuItems.forEach((item) => {
      item.classList.remove(CLASSES.menuItemSubmenuShow);
      const link = item.querySelector('.menu__link');
      const parentHasSubmenuClass = item.classList.contains('menu__item--submenu');
      if (link && (link.tagName.toLowerCase() === 'a' || parentHasSubmenuClass)) {
        link.classList.remove(CLASSES.menuLinkActive);
      }
    });

    // Если текущее подменю не было открыто, открываем его
    if (!isOpenSubmenu) {
      currentItem.classList.add(CLASSES.menuItemSubmenuShow);
      evt.target.classList.add(CLASSES.menuLinkActive);
    }
  };

  const clickButtonMenuHandler = (evt) => {
    evt.preventDefault();

    buttonMenu.classList.toggle(CLASSES.iconMenu);
    buttonMenu.classList.toggle(CLASSES.iconClose);

    headerMenuContainer.classList.toggle(CLASSES.headerNavigationOpenMenu);
    headerMenu.classList.toggle(CLASSES.headerMenuShow);

    if (buttonMenu.hasAttribute('data-compensate-scrollbar') || window.innerWidth < BREAKPOINTS.mobile) {
      page.classList.toggle(CLASSES.pageFixed);
      compensateForScrollbar();
    }
  };

  const initButtonMenu = () => {
    buttonMenu.addEventListener('click', clickButtonMenuHandler);

    if (window.innerWidth < BREAKPOINTS.mobile) {
      menuItemsSubmenu.forEach((item) => {
        item.addEventListener('click', clickMenuItemSubmenuHandler);
      });
    }
  };

  const resetMenuState = () => {
    headerMenuContainer.classList.remove(CLASSES.headerNavigationOpenMenu);
    headerMenu.classList.remove(CLASSES.headerMenuShow);

    buttonMenu.classList.add(CLASSES.iconMenu);
    buttonMenu.classList.remove(CLASSES.iconClose);

    page.classList.remove(CLASSES.pageFixed);

    compensateForScrollbar(true);
  };

  const resizeHandler = () => {
    const previousWidth = screen.width;
    screen = {
      width: window.innerWidth,
      height: window.innerHeight
    };

    if (previousWidth >= BREAKPOINTS.mobile && screen.width < BREAKPOINTS.mobile) {
      menuItemsSubmenu.forEach((item) => {
        item.addEventListener('click', clickMenuItemSubmenuHandler);
      });

      resetMenuState();
    }

    if (previousWidth < BREAKPOINTS.mobile && screen.width >= BREAKPOINTS.mobile) {
      menuItemsSubmenu.forEach((item) => {
        item.removeEventListener('click', clickMenuItemSubmenuHandler);
      });

      resetMenuState();
    }
  };

  const documentClickHandler = (evt) => {
    if (!evt.target.closest('.menu__item--submenu')) {
      menuItemsSubmenu.forEach((item) => {
        const parentItem = item.parentElement;
        parentItem.classList.remove(CLASSES.menuItemSubmenuShow);
        const parentHasSubmenuClass = parentItem.classList.contains('menu__item--submenu');
        if (item.tagName.toLowerCase() === 'a' || parentHasSubmenuClass) {
          item.classList.remove(CLASSES.menuLinkActive);
        }
      });
    }
  };

  initButtonMenu();
  window.addEventListener('resize', resizeHandler);
  document.addEventListener('click', documentClickHandler);
});
